import { add } from '../../customers/services/CustomersService';
import { generatePersonName, generateCompanyName } from './nameGenerators';

const generatePersonData = () => {
  const name = generatePersonName();
  const firstName = name.split(' ')[0].toLowerCase();
  const lastName = name.split(' ')[1]?.toLowerCase() || 'user';
  return {
    name,
    description: `Individual customer - ${name}`,
    status: 'ACTIVE',
    contactInfo: {
      email: `${firstName}.${lastName}@example.com`
    }
  };
};

const generateCompanyData = () => {
  const name = generateCompanyName();
  const companySlug = name.toLowerCase().replace(/[^a-z0-9]/g, '');
  return {
    name,
    description: `Business customer - ${name}`,
    status: 'ACTIVE',
    contactInfo: {
      email: `contact@${companySlug}.com`
    }
  };
};

const generateCustomerData = () => {
  // 60% chance for person, 40% chance for company
  return Math.random() < 0.6 ? generatePersonData() : generateCompanyData();
};

export const generateCustomersTestData = async (count: number) => {
  const promises = [];
  
  for (let i = 1; i <= count; i++) {
    const customerData = generateCustomerData();
    promises.push(add(customerData));
  }
  
  try {
    const results = await Promise.all(promises);
    console.log(`Generated ${count} test customers`);
    return results.filter(Boolean);
  } catch (error) {
    console.error('Error generating customer test data:', error);
    return [];
  }
};